import { VxlSpacing } from '@varo/graphql-schema-types';
import spacing from 'shared/styles/spacing';
import theme from 'shared/styles/theme';

const getVXLSpacing = (spacingValue: VxlSpacing) => {
  const spacingKey =
    spacingValue !== VxlSpacing.SpaceZero
      ? spacingValue.replace(/^[^_]*_/, '').toLowerCase()
      : undefined;
  return spacing[spacingKey as keyof typeof theme.spacing];
};

export { getVXLSpacing };
